export default __webpack_public_path__ + "images/0x4eac4c4e9050464067d673102f8e24b2fcceb350.png";